import { KeplrWalletConnector } from './KeplrWalletConnector.js';
export { KeplrWalletConnector } from './KeplrWalletConnector.js';

/* eslint-disable @typescript-eslint/no-unused-vars */
const KeplrWalletConnectors = (props) => [KeplrWalletConnector];

export { KeplrWalletConnectors };
